export declare type EncodableData = Record<string, unknown>;

export const isValidStruct = ( value: unknown ): value is EncodableData => {
	if(typeof value === "object" && !Array.isArray(value) && value !== null) {
		if("type" in value && typeof value.type === "string" && value.type.length) {
			return true;
		}
	}
}

export const encode = ( data, ) => {
	try {
		if(isValidStruct(data)) {
			try {
				return JSON.stringify(data, (k, v) => typeof v === "bigint" ? `__BI|${v.toString()}` : v, 0);
			}
			catch( err ) {
				console.error("failed to stringify data", err);
				throw new Error("cannot stringify data.");
			}
		}
		throw new Error("invalid data struct argued");
	}
	catch(err) {
		throw new Error(`@bracket/rabbit encode failed - ${err.message}`);
	}
}

export const decode = ( message: string, ) => {
	try {
		try {
			return JSON.parse(message, ( k, v ) => {
				if(typeof v === "string" && v.startsWith("__BI")) {
					const numpart = v.split("|")[1];
					if(/^[0-9]+$/.test(numpart)) {
						return BigInt(numpart);
					}
				}
				return v;
			})
		}
		catch( err ) {
			throw new Error(`error decoding -- ${err.message} `);
		}
	}
	catch( err ) {
		throw new Error(`@bracket/rabbit decode failed - ${err.message}`);
	}
}
